// Mock data for La Rosa Negra Hotel - WITH ALL ROOM-SPECIFIC IMAGES

export const hotelInfo = {
  name: "Hotel La Rosa Negra",
  tagline: "Family-run 3-star hotel, 2 minutes from Velika Plaža, Ulcinj",
  description: "Simple, family-run 3-star hotel about 2 minutes on foot from Velika Plaža in Ulcinj, Montenegro. Breakfast, dinner, pool, Wi-Fi and garage parking included.",
  rating: 7.4,
  reviewCount: 759,
  stars: 3,
  location: "Kepi i Gjeranave, Long beach, Ulcinj, Montenegro",
  address: "Rr. Kepi i Gjeranve Port Milena Hotel Rosa Negra",
  city: "Ulcinj",
  postalCode: "85360",
  country: "Montenegro",
  phone: "+382 69 533 984",
  email: "larosaulcinj@gmail.com",
  whatsapp: "38269533984",
  beds24Id: "231163",
  bookingComUrl: "https://www.booking.com/hotel/me/rosa-negra.html",
  virtualTour: "https://virtualtours.virtualno360.hr/F1GtPWMYfJ",
  virtualTourIframe: "https://virtualtours.virtualno360.hr/F1GtPWMYfJ",
  mapUrl: "https://maps.app.goo.gl/LEUHhov5cBzN9jvz6",
  coordinates: { lat: 41.9184, lng: 19.2423 },
  social: {
    facebook: "https://www.facebook.com/larosanegrahotel/",
    instagram: "https://www.instagram.com/larosanegrahotel/",
    tiktok: "https://www.tiktok.com/@hotel.la.rosa.neg"
  }
};

export const rooms = [
  {
    "id": 1,
    "name": "Triple Room with Shared Terrace",
    "size": 25,
    "guests": 3,
    "price": 85,
    "description": "Comfortable triple room featuring 1 twin bed and 1 queen bed. Perfect for small families or groups of friends. Includes access to a shared terrace, air conditioning, free WiFi, flat-screen TV, wardrobe, desk, and private bathroom with shower and free toiletries.",
    "amenities": [
      "Shared Terrace",
      "Air Conditioning",
      "Free WiFi",
      "Wardrobe & Desk"
    ],
    "images": [
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/406119973.jpg?k=fb8497d1920659cfad1bca7698a7ed10e9e441226f11ecdbd2793ea3e79ef995&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462356.jpg?k=8f8897f1e6ad0960acbbd01f9914d9c630e2754e89605185861d157ef8876226&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587574.jpg?k=032f83580f4cb215eb4c60b08082ce768f435b765f71507d18cbbedb9605a0f8&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462364.jpg?k=05af0ab224b861572b76d469dddd6bd0abb39688cf5990cb38a172c36319ac8e&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487415.jpg?k=fb3cbc4adb4460391b420a1ffc7989e0890fe803417daf91ebdb7939789aa986&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487412.jpg?k=ff24fccaf0c55c99944e7786cd3a3aabf3882352d8d62af3a7eaba53e62d73ae&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462352.jpg?k=74f74428972ebdacbbee9db68d31ca7ceb2598000417807224216c4e56a1fc5b&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288681.jpg?k=267a30ca91bb636e8b35aeb2018495a91350de37bb2340416ed9f1cde4b0aaf1&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/653748693.jpg?k=529aff3d2f211313738f4963af4ed90a8e5a213c9a47b4890b2b7828dc85093e&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/653750221.jpg?k=593df7aa8ec5e25f68a4af123bb357f88137b51b89a0a3ac732cdb84677494aa&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/653750240.jpg?k=172a8983fb579cdd899033d7c070240af7447357bb1daf737d73d1cb8d9cc3da&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/653750249.jpg?k=b734752024204d20759ad6bfe9c069d220f19e02cbed4fa1d117924e33234de4&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/653750266.jpg?k=343b8f382a2fa6f5b4f09d7c76fce2d536a13518a863779b1a5a44da19ef7fe0&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/653750277.jpg?k=7681a4af8248af8e6f339c6ad9a16a5b5587974c013be36f0600b1f983c0164e&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/653750284.jpg?k=77090d8dde0fa58843681df724c603596e9a73da360d8c893bee839d1c923b01&o="
    ]
  },
  {
    "id": 2,
    "name": "Deluxe Double Room with Extra Bed",
    "size": 22,
    "guests": 3,
    "price": 95,
    "description": "Spacious deluxe room with 1 sofa bed and 1 queen bed, ideal for couples or small families needing extra sleeping space. Features modern amenities including air conditioning, desk, wardrobe, flat-screen TV, and private bathroom with shower and free toiletries.",
    "amenities": [
      "Sofa Bed",
      "Queen Bed",
      "Air Conditioning",
      "Free WiFi"
    ],
    "images": [
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/406119973.jpg?k=fb8497d1920659cfad1bca7698a7ed10e9e441226f11ecdbd2793ea3e79ef995&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462356.jpg?k=8f8897f1e6ad0960acbbd01f9914d9c630e2754e89605185861d157ef8876226&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587574.jpg?k=032f83580f4cb215eb4c60b08082ce768f435b765f71507d18cbbedb9605a0f8&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462364.jpg?k=05af0ab224b861572b76d469dddd6bd0abb39688cf5990cb38a172c36319ac8e&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487415.jpg?k=fb3cbc4adb4460391b420a1ffc7989e0890fe803417daf91ebdb7939789aa986&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487412.jpg?k=ff24fccaf0c55c99944e7786cd3a3aabf3882352d8d62af3a7eaba53e62d73ae&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462352.jpg?k=74f74428972ebdacbbee9db68d31ca7ceb2598000417807224216c4e56a1fc5b&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288681.jpg?k=267a30ca91bb636e8b35aeb2018495a91350de37bb2340416ed9f1cde4b0aaf1&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288773.jpg?k=4ffd6aca663376c7c6ff6b0d685ebc3a75c30c690182fc0e694aac869be7e95d&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288688.jpg?k=3e9160c42556d1abe4f9ff9423fc68088e655609fb369bf4f2e413cd27cef60a&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288457.jpg?k=43eb63803ef1d1e4c6dd474a22667e4583e77ef70ca4e5321500b11259942a13&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320485909.jpg?k=691d4258a0f55f70e5d7aed862c9c278631f4d73a9558710fd1e967abea8d139&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320486500.jpg?k=b12403cd4e586a7f7ba6786e78b088cdb6500d2e1a3d6bb01baaa4d671bb21fd&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320486758.jpg?k=73d50f7302f1fcd5a0427bf091328d06b126d66b816f41aef56010d918426363&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320486768.jpg?k=53b32f9ae1ea246f11ae7abe79dc287435af2aa3f435ff7dcd74a185ad2a1c87&o="
    ]
  },
  {
    "id": 3,
    "name": "Family Room with Terrace",
    "size": 35,
    "guests": 5,
    "price": 145,
    "description": "Spacious family room perfect for larger families, featuring 1 twin bed, 1 sofa bed, and 1 queen bed. Includes a private terrace with beautiful views, air conditioning, desk, wardrobe, and all modern conveniences. Ideal for families with children.",
    "amenities": [
      "Private Terrace",
      "Family Friendly",
      "Multiple Beds",
      "Air Conditioning"
    ],
    "images": [
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/406119973.jpg?k=fb8497d1920659cfad1bca7698a7ed10e9e441226f11ecdbd2793ea3e79ef995&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462356.jpg?k=8f8897f1e6ad0960acbbd01f9914d9c630e2754e89605185861d157ef8876226&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587574.jpg?k=032f83580f4cb215eb4c60b08082ce768f435b765f71507d18cbbedb9605a0f8&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462364.jpg?k=05af0ab224b861572b76d469dddd6bd0abb39688cf5990cb38a172c36319ac8e&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487415.jpg?k=fb3cbc4adb4460391b420a1ffc7989e0890fe803417daf91ebdb7939789aa986&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487412.jpg?k=ff24fccaf0c55c99944e7786cd3a3aabf3882352d8d62af3a7eaba53e62d73ae&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462352.jpg?k=74f74428972ebdacbbee9db68d31ca7ceb2598000417807224216c4e56a1fc5b&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288681.jpg?k=267a30ca91bb636e8b35aeb2018495a91350de37bb2340416ed9f1cde4b0aaf1&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/575593378.jpg?k=d5687e2112b0c678dba2de717c4d10c5043ea5f129715106eaee37065a9f4390&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288864.jpg?k=9bd20fbd0eb6bc3dfc69df63bbd2fa1409492aabdbd893887feadac062eddf1b&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320486471.jpg?k=e6c485ceacd4c0a9e394d1177f13a890040eecc13e8043b887eaa2a1acbec10c&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487014.jpg?k=aedb2eacfb811d2a1c25ce6bd66f43671fd17098d14aca8b071a2356ab4041e0&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320486117.jpg?k=d64c9e0a26f6a244322ff180ec5faa89188c98435aa0403e6334cb5aef49aec1&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320486978.jpg?k=cc8018b032b4b4efb03cdc9e0b210599ea503f92771a692076142b7157e6d326&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320486991.jpg?k=1e2a85d3d6b0d46023dac3ccb68df62e77217f82bcefde321d0501d4cf57c6a2&o="
    ]
  },
  {
    "id": 4,
    "name": "Executive Triple Room",
    "size": 28,
    "guests": 4,
    "price": 115,
    "description": "Executive triple room with 1 sofa bed and 1 queen bed, offering comfortable accommodation for up to 4 guests. Features air conditioning, wardrobe, desk, flat-screen TV, and private bathroom. Great for families or groups looking for extra space.",
    "amenities": [
      "Sofa Bed",
      "Queen Bed",
      "Air Conditioning",
      "Executive Room"
    ],
    "images": [
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/406119973.jpg?k=fb8497d1920659cfad1bca7698a7ed10e9e441226f11ecdbd2793ea3e79ef995&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462356.jpg?k=8f8897f1e6ad0960acbbd01f9914d9c630e2754e89605185861d157ef8876226&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587574.jpg?k=032f83580f4cb215eb4c60b08082ce768f435b765f71507d18cbbedb9605a0f8&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462364.jpg?k=05af0ab224b861572b76d469dddd6bd0abb39688cf5990cb38a172c36319ac8e&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487415.jpg?k=fb3cbc4adb4460391b420a1ffc7989e0890fe803417daf91ebdb7939789aa986&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487412.jpg?k=ff24fccaf0c55c99944e7786cd3a3aabf3882352d8d62af3a7eaba53e62d73ae&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462352.jpg?k=74f74428972ebdacbbee9db68d31ca7ceb2598000417807224216c4e56a1fc5b&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288681.jpg?k=267a30ca91bb636e8b35aeb2018495a91350de37bb2340416ed9f1cde4b0aaf1&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288792.jpg?k=52a5853f0b0ed5a4f12dced4264f8eb4a829fbdec6cb0fa85dd8ac109b3adfe8&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320485909.jpg?k=691d4258a0f55f70e5d7aed862c9c278631f4d73a9558710fd1e967abea8d139&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288772.jpg?k=15230267ed509b00ea62db367d660d6a6375b4a963d971c418eea1ea2e955146&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/406119970.jpg?k=9094930b088cf900a91880efacc77d354abe93a7b0777587cb676e5d667cf098&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288697.jpg?k=40cadac123e80460fab40f9ba613ac6dd8a2e934c3f60eb22e43df3993aff97d&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/473275455.jpg?k=c11c0a63193d362e346d17803bcfa3493ccd61e9257d4e7a19053fa5b52d4fa6&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288731.jpg?k=94d15e797ab56e39e235e1325394fbf1369bdc5e174fba9ae789fb2a0dcdbaaa&o="
    ]
  },
  {
    "id": 5,
    "name": "Twin Room with Shared Terrace",
    "size": 20,
    "guests": 2,
    "price": 75,
    "description": "Comfortable twin room with 2 twin beds and access to a shared terrace. Perfect for friends or colleagues traveling together. Includes air conditioning, free WiFi, wardrobe, desk, and private bathroom with shower.",
    "amenities": [
      "2 Twin Beds",
      "Shared Terrace",
      "Air Conditioning",
      "Free WiFi"
    ],
    "images": [
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/406119973.jpg?k=fb8497d1920659cfad1bca7698a7ed10e9e441226f11ecdbd2793ea3e79ef995&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462356.jpg?k=8f8897f1e6ad0960acbbd01f9914d9c630e2754e89605185861d157ef8876226&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587574.jpg?k=032f83580f4cb215eb4c60b08082ce768f435b765f71507d18cbbedb9605a0f8&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462364.jpg?k=05af0ab224b861572b76d469dddd6bd0abb39688cf5990cb38a172c36319ac8e&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487415.jpg?k=fb3cbc4adb4460391b420a1ffc7989e0890fe803417daf91ebdb7939789aa986&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487412.jpg?k=ff24fccaf0c55c99944e7786cd3a3aabf3882352d8d62af3a7eaba53e62d73ae&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462352.jpg?k=74f74428972ebdacbbee9db68d31ca7ceb2598000417807224216c4e56a1fc5b&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288681.jpg?k=267a30ca91bb636e8b35aeb2018495a91350de37bb2340416ed9f1cde4b0aaf1&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487004.jpg?k=18234eb646e1fff0e036b076a7db24ad70a4fee9f4d57b52e8b09fa380c9aa0b&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320486471.jpg?k=e6c485ceacd4c0a9e394d1177f13a890040eecc13e8043b887eaa2a1acbec10c&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320486991.jpg?k=1e2a85d3d6b0d46023dac3ccb68df62e77217f82bcefde321d0501d4cf57c6a2&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/575593378.jpg?k=d5687e2112b0c678dba2de717c4d10c5043ea5f129715106eaee37065a9f4390&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487015.jpg?k=766a72d279c5e35290bb575751c71c44285ef3a8634dbb684ca1cbdf9c52f60f&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487362.jpg?k=074f6d732f808da2a522578c63090c9ead151fd91cbece44e797f04c8efb4913&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487367.jpg?k=beac6a0d85c851485669dc7ce6d6459084bb7ea5f6924e6a8da0aba9587cd943&o="
    ]
  },
  {
    "id": 6,
    "name": "Economy Double Room",
    "size": 16,
    "guests": 2,
    "price": 65,
    "description": "Compact and affordable double room with 1 queen bed, perfect for budget-conscious travelers. Features all essential amenities including air conditioning, private bathroom with shower, free WiFi, wardrobe, and desk.",
    "amenities": [
      "Queen Bed",
      "Air Conditioning",
      "Free WiFi",
      "Private Bathroom"
    ],
    "images": [
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/406119973.jpg?k=fb8497d1920659cfad1bca7698a7ed10e9e441226f11ecdbd2793ea3e79ef995&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462356.jpg?k=8f8897f1e6ad0960acbbd01f9914d9c630e2754e89605185861d157ef8876226&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587574.jpg?k=032f83580f4cb215eb4c60b08082ce768f435b765f71507d18cbbedb9605a0f8&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462364.jpg?k=05af0ab224b861572b76d469dddd6bd0abb39688cf5990cb38a172c36319ac8e&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487415.jpg?k=fb3cbc4adb4460391b420a1ffc7989e0890fe803417daf91ebdb7939789aa986&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487412.jpg?k=ff24fccaf0c55c99944e7786cd3a3aabf3882352d8d62af3a7eaba53e62d73ae&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462352.jpg?k=74f74428972ebdacbbee9db68d31ca7ceb2598000417807224216c4e56a1fc5b&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288681.jpg?k=267a30ca91bb636e8b35aeb2018495a91350de37bb2340416ed9f1cde4b0aaf1&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/472810417.jpg?k=3cc64acfaca1b677cee16fc3cb5376a43b175972ff33dc46b734784db3ee17e7&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/472810425.jpg?k=6eb446db938fa33d59dad7e33b51e0ffb7acdb80b11130cfcd662ee22e81eeb5&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/472810430.jpg?k=8dc41614084521cecf193f7a48c5ef433b78486c3469036e0e9704efc0917d21&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/472810438.jpg?k=bcfe8466d78cd329d3d86e86fa7e89f2b57d5d0df0b93b17a01e288d96219ecf&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/472810445.jpg?k=a59a4379e05b8944c61004a82ecc828f9fabb28c2623a0b4f619a00a7801dd36&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/472810452.jpg?k=4dbd5466169748973051063bc06cd62d0cef821961a961c94af35573545aa202&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/472810460.jpg?k=655e861a5fb47a31d7140a7ec69f67edfbaf3a807a9ba16fb093386aab2e8e32&o="
    ]
  },
  {
    "id": 7,
    "name": "Double Room with Balcony and Sea View",
    "size": 20,
    "guests": 2,
    "price": 135,
    "description": "Elegant double room with stunning sea view balcony featuring 1 queen bed. Wake up to breathtaking views of the Adriatic Sea. Includes modern furnishings, air conditioning, flat-screen TV, mini fridge, wardrobe, and private bathroom with free toiletries.",
    "amenities": [
      "Sea View Balcony",
      "Queen Bed",
      "Air Conditioning",
      "Mini fridge"
    ],
    "images": [
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/406119973.jpg?k=fb8497d1920659cfad1bca7698a7ed10e9e441226f11ecdbd2793ea3e79ef995&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462356.jpg?k=8f8897f1e6ad0960acbbd01f9914d9c630e2754e89605185861d157ef8876226&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587574.jpg?k=032f83580f4cb215eb4c60b08082ce768f435b765f71507d18cbbedb9605a0f8&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462364.jpg?k=05af0ab224b861572b76d469dddd6bd0abb39688cf5990cb38a172c36319ac8e&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487415.jpg?k=fb3cbc4adb4460391b420a1ffc7989e0890fe803417daf91ebdb7939789aa986&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487412.jpg?k=ff24fccaf0c55c99944e7786cd3a3aabf3882352d8d62af3a7eaba53e62d73ae&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462352.jpg?k=74f74428972ebdacbbee9db68d31ca7ceb2598000417807224216c4e56a1fc5b&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288681.jpg?k=267a30ca91bb636e8b35aeb2018495a91350de37bb2340416ed9f1cde4b0aaf1&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462361.jpg?k=b732d569be1b37a4f9d898bc8d865f7595bdf41fff2b0275123eff76b40b60cb&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288435.jpg?k=4507faf2991895a177299556154f84776838923ead925140eb72ba83eb151a03&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288288.jpg?k=99e6cb44b221d64cfc9d06416b868ff87672b6b9bab785d98efdf0973795fbae&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288719.jpg?k=842267c8a75f3e710a7555a7b1043ee3114ff62a9d714ffeb38d88de1c3870c2&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/575593374.jpg?k=8bcdfc57993224b75f2940ea08b96914f7ff6c1a3e229b286bfde5fa28ee2e0c&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462381.jpg?k=4b5e49ae5d54b64d7af94ea4608a4bf7c98f17dddbf8f2531606e1cb331fbf2d&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/472810466.jpg?k=da7a77e921055f75f74d12c5c81be1b908bfdebc5d72130b60b29836d1adeee1&o="
    ]
  },
  {
    "id": 8,
    "name": "Two-Bedroom Family Apartment",
    "size": 55,
    "guests": 4,
    "price": 195,
    "description": "Luxurious two-bedroom apartment ideal for families. Bedroom 1 has 1 queen bed, Bedroom 2 has 1 twin bed, and the living room features 1 sofa bed. Includes kitchenette, private bathroom, and all modern amenities. Perfect for longer stays and families needing extra space.",
    "amenities": [
      "Two Bedrooms",
      "Kitchenette",
      "Living Room",
      "Sofa Bed"
    ],
    "images": [
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/406119973.jpg?k=fb8497d1920659cfad1bca7698a7ed10e9e441226f11ecdbd2793ea3e79ef995&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462356.jpg?k=8f8897f1e6ad0960acbbd01f9914d9c630e2754e89605185861d157ef8876226&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587574.jpg?k=032f83580f4cb215eb4c60b08082ce768f435b765f71507d18cbbedb9605a0f8&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462364.jpg?k=05af0ab224b861572b76d469dddd6bd0abb39688cf5990cb38a172c36319ac8e&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487415.jpg?k=fb3cbc4adb4460391b420a1ffc7989e0890fe803417daf91ebdb7939789aa986&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487412.jpg?k=ff24fccaf0c55c99944e7786cd3a3aabf3882352d8d62af3a7eaba53e62d73ae&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462352.jpg?k=74f74428972ebdacbbee9db68d31ca7ceb2598000417807224216c4e56a1fc5b&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288681.jpg?k=267a30ca91bb636e8b35aeb2018495a91350de37bb2340416ed9f1cde4b0aaf1&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/657999729.jpg?k=ac2a1775f1b069cf7e61984e5d87da0f2d1c7ee51975504c9292d4e53434a775&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462381.jpg?k=4b5e49ae5d54b64d7af94ea4608a4bf7c98f17dddbf8f2531606e1cb331fbf2d&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/657999731.jpg?k=a56728fdbf51b224bb3ad3de103be21bd668e700c0f2200f18a5077f6c66c2f0&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462361.jpg?k=b732d569be1b37a4f9d898bc8d865f7595bdf41fff2b0275123eff76b40b60cb&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462366.jpg?k=0deb39e9c106ed2e7454a9a6d408dcf115020e94ab72a6e457df58967519768c&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/657999734.jpg?k=51977fd6a3ac2c8f6e1ab01cee001d68d858c789b6d0ae3566a2b9f006b921e9&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/657999735.jpg?k=35ec8775847d6589f43ad138df0a4355ca59ab206a7840f607370e7e29306460&o="
    ]
  },
  {
    "id": 9,
    "name": "Family Room with Mountain View",
    "size": 32,
    "guests": 3,
    "price": 125,
    "description": "Comfortable family room with peaceful mountain views, featuring 1 sofa bed and 1 queen bed. Enjoy the serene mountain scenery while having access to all hotel amenities. Includes air conditioning, free WiFi, wardrobe, desk, and private bathroom.",
    "amenities": [
      "Mountain View",
      "Sofa Bed",
      "Queen Bed",
      "Air Conditioning"
    ],
    "images": [
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/406119973.jpg?k=fb8497d1920659cfad1bca7698a7ed10e9e441226f11ecdbd2793ea3e79ef995&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462356.jpg?k=8f8897f1e6ad0960acbbd01f9914d9c630e2754e89605185861d157ef8876226&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587574.jpg?k=032f83580f4cb215eb4c60b08082ce768f435b765f71507d18cbbedb9605a0f8&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462364.jpg?k=05af0ab224b861572b76d469dddd6bd0abb39688cf5990cb38a172c36319ac8e&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487415.jpg?k=fb3cbc4adb4460391b420a1ffc7989e0890fe803417daf91ebdb7939789aa986&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487412.jpg?k=ff24fccaf0c55c99944e7786cd3a3aabf3882352d8d62af3a7eaba53e62d73ae&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462352.jpg?k=74f74428972ebdacbbee9db68d31ca7ceb2598000417807224216c4e56a1fc5b&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288681.jpg?k=267a30ca91bb636e8b35aeb2018495a91350de37bb2340416ed9f1cde4b0aaf1&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587576.jpg?k=1b46529e95dc867c32a10f3506e8e3e4300d9ac92af79022aecf3ceed1c4049f&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587570.jpg?k=e13ee0b3fefe303439c278531c57efc0c3f30e36da587bcff03a3c4efc2baed7&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587560.jpg?k=2156f089bf91d04ffb9bab86ebf28e60a25af617ededd609a82ee0276f646282&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587559.jpg?k=f9512791176c66a6992b3844e2f12c22cf4e0abf473ad48d7d7ca444589d841d&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587565.jpg?k=9728fda29960d1ddaf6102f3b47db741abf4910d6823f0593baa1b72a58b6655&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462343.jpg?k=3aadd8d3bb04ae286d720d097accdcc9c1e3f86865752d30884e6b378525434a&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320485915.jpg?k=0104876ac81fae7ffc90d10146c54e959787cbd8f269baeacc10f559770da039&o="
    ]
  },
  {
    "id": 10,
    "name": "Double Room with Pool View",
    "size": 18,
    "guests": 2,
    "price": 105,
    "description": "Cozy double room overlooking the hotel's beautiful pool area, featuring 1 queen bed. Perfect for couples seeking a relaxing getaway with easy pool access. Includes air conditioning, work desk, wardrobe, flat-screen TV, and private bathroom with shower.",
    "amenities": [
      "Pool View",
      "Queen Bed",
      "Work Desk",
      "Air Conditioning"
    ],
    "images": [
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/406119973.jpg?k=fb8497d1920659cfad1bca7698a7ed10e9e441226f11ecdbd2793ea3e79ef995&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462356.jpg?k=8f8897f1e6ad0960acbbd01f9914d9c630e2754e89605185861d157ef8876226&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587574.jpg?k=032f83580f4cb215eb4c60b08082ce768f435b765f71507d18cbbedb9605a0f8&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462364.jpg?k=05af0ab224b861572b76d469dddd6bd0abb39688cf5990cb38a172c36319ac8e&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487415.jpg?k=fb3cbc4adb4460391b420a1ffc7989e0890fe803417daf91ebdb7939789aa986&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487412.jpg?k=ff24fccaf0c55c99944e7786cd3a3aabf3882352d8d62af3a7eaba53e62d73ae&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462352.jpg?k=74f74428972ebdacbbee9db68d31ca7ceb2598000417807224216c4e56a1fc5b&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288681.jpg?k=267a30ca91bb636e8b35aeb2018495a91350de37bb2340416ed9f1cde4b0aaf1&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462343.jpg?k=3aadd8d3bb04ae286d720d097accdcc9c1e3f86865752d30884e6b378525434a&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320486088.jpg?k=fcaedd66e4365981dfabff5e5866ab588bfa59abe807d3efa8e99ef5275225d3&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320486508.jpg?k=b74b97d024f9ee25fe3595b0b467f415aee063867a62dab25ff7bacccbe9c4ba&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320486500.jpg?k=b12403cd4e586a7f7ba6786e78b088cdb6500d2e1a3d6bb01baaa4d671bb21fd&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320486493.jpg?k=84c7460627ee62a1a9521d000e823edb5fef8d220b0f62d28ccd497491f35e6d&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320486486.jpg?k=c5c2ce9a03ffd6cbb0c0071bef891416ec1a448bc2073732da694902ea2dba4e&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288677.jpg?k=9aeb6b90bdbbb3ad072eb408b7747e8d89fece183edd7ef9865ef10ed7afffc5&o="
    ]
  },
  {
    "id": 11,
    "name": "One-Bedroom Apartment with Balcony",
    "size": 45,
    "guests": 4,
    "price": 175,
    "description": "Spacious one-bedroom apartment with private balcony. The bedroom features 2 twin beds and the living room has 1 sofa bed. Includes a fully equipped kitchenette with dining area, making it perfect for longer stays. All modern amenities included.",
    "amenities": [
      "Kitchenette",
      "Balcony",
      "Living Area",
      "Twin Beds"
    ],
    "images": [
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/406119973.jpg?k=fb8497d1920659cfad1bca7698a7ed10e9e441226f11ecdbd2793ea3e79ef995&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462356.jpg?k=8f8897f1e6ad0960acbbd01f9914d9c630e2754e89605185861d157ef8876226&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587574.jpg?k=032f83580f4cb215eb4c60b08082ce768f435b765f71507d18cbbedb9605a0f8&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462364.jpg?k=05af0ab224b861572b76d469dddd6bd0abb39688cf5990cb38a172c36319ac8e&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487415.jpg?k=fb3cbc4adb4460391b420a1ffc7989e0890fe803417daf91ebdb7939789aa986&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487412.jpg?k=ff24fccaf0c55c99944e7786cd3a3aabf3882352d8d62af3a7eaba53e62d73ae&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462352.jpg?k=74f74428972ebdacbbee9db68d31ca7ceb2598000417807224216c4e56a1fc5b&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288681.jpg?k=267a30ca91bb636e8b35aeb2018495a91350de37bb2340416ed9f1cde4b0aaf1&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/653748693.jpg?k=529aff3d2f211313738f4963af4ed90a8e5a213c9a47b4890b2b7828dc85093e&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/653750210.jpg?k=e25bcfbc53bf1a9c9952ed8fd93dd258da13ccd95b7c9f52a4957af99877ce16&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/653750221.jpg?k=593df7aa8ec5e25f68a4af123bb357f88137b51b89a0a3ac732cdb84677494aa&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/653750225.jpg?k=0abf377e1c8eb71992208e268159445dd04e200df949433a9b6d074cf99aff79&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/653750233.jpg?k=dc092019a7f4049d649f693a012b46e1d4aa25013408c433d9594baf745f943d&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/653750240.jpg?k=172a8983fb579cdd899033d7c070240af7447357bb1daf737d73d1cb8d9cc3da&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/653750249.jpg?k=b734752024204d20759ad6bfe9c069d220f19e02cbed4fa1d117924e33234de4&o="
    ]
  },
  {
    "id": 12,
    "name": "Small Single Room (No Window)",
    "size": 12,
    "guests": 1,
    "price": 45,
    "description": "Compact single room with 1 twin bed, ideal for solo budget travelers. While this room has no window, it includes all essential amenities: air conditioning, private bathroom with shower, free WiFi, wardrobe, and desk. Perfect for short stays.",
    "amenities": [
      "Single Bed",
      "Air Conditioning",
      "Free WiFi",
      "Budget Room"
    ],
    "images": [
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/406119973.jpg?k=fb8497d1920659cfad1bca7698a7ed10e9e441226f11ecdbd2793ea3e79ef995&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462356.jpg?k=8f8897f1e6ad0960acbbd01f9914d9c630e2754e89605185861d157ef8876226&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587574.jpg?k=032f83580f4cb215eb4c60b08082ce768f435b765f71507d18cbbedb9605a0f8&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462364.jpg?k=05af0ab224b861572b76d469dddd6bd0abb39688cf5990cb38a172c36319ac8e&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487415.jpg?k=fb3cbc4adb4460391b420a1ffc7989e0890fe803417daf91ebdb7939789aa986&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487412.jpg?k=ff24fccaf0c55c99944e7786cd3a3aabf3882352d8d62af3a7eaba53e62d73ae&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462352.jpg?k=74f74428972ebdacbbee9db68d31ca7ceb2598000417807224216c4e56a1fc5b&o=",
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288681.jpg?k=267a30ca91bb636e8b35aeb2018495a91350de37bb2340416ed9f1cde4b0aaf1&o="
    ]
  }
];

export const amenities = [
  {
    icon: "Waves",
    title: "Beachfront Location",
    description: "About 2 minutes on foot to Long Beach, the longest sandy beach in Montenegro"
  },
  {
    icon: "Baby",
    title: "Children's Pool",
    description: "Safe and fun children's pool for families with young ones"
  },
  {
    icon: "Utensils",
    title: "Restaurant & Café",
    description: "On-site restaurant with Balkan and international cuisine"
  },
  {
    icon: "Wifi",
    title: "Free WiFi",
    description: "Complimentary high-speed internet throughout the property"
  },
  {
    icon: "Car",
    title: "Free Parking",
    description: "Secure free private parking available for all guests"
  },
  {
    icon: "Plane",
    title: "Airport Shuttle",
    description: "Paid airport transfer from Podgorica (TGD) & Tivat (TIV) — €80, on request"
  },
  {
    icon: "Clock",
    title: "24-Hour Front Desk",
    description: "Round-the-clock reception and concierge service"
  },
  {
    icon: "Hotel",
    title: "Elevator Access",
    description: "Convenient elevator access to all floors"
  }
];

export const services = [
  {
    title: "Laundry Service",
    price: "€7.00",
    description: "Professional laundry and washing service",
    icon: "Shirt"
  },
  {
    title: "Airport Transfer",
    price: "€80.00",
    description: "Airport pickup & drop-off from Podgorica (TGD) and Tivat (TIV)",
    icon: "Plane"
  },
  {
    title: "Rent a Car",
    price: "€60.00",
    description: "Convenient car rental service",
    icon: "Car"
  }
];

export const testimonials = [
  {
    name: "Aleksandra Zrinjanin",
    date: "2024-10-15",
    rating: 9,
    text: "Hotel La Rosa Negra enhanced my stay with its excellent amenities and supportive staff. The sea-view room and local excursions were highlights. The efficient service saved me time and stress. Highly recommend!"
  },
  {
    name: "Vanja Prazina",
    date: "2024-10-15",
    rating: 9,
    text: "Our team consistently enjoys Hotel La Rosa Negra. The rooms are comfortable, with stunning sea views. The service is impeccable, and the pools are refreshing. The restaurant serves delicious Balkan and international cuisine. Highly recommended!"
  },
  {
    name: "Nedzad Honsic",
    date: "2024-10-15",
    rating: 9,
    text: "Hotel La Rosa Negra transformed my stay with seamless service, stunning sea view rooms, and exceptional dining. The friendly staff and top-notch facilities made my visit truly memorable."
  },
  {
    name: "Ana Damnjanović",
    date: "2024-10-16",
    rating: 9,
    text: "We had an excellent stay at Hotel La Rosa Negra. The rooms were comfortable with stunning sea views. We enjoyed the rooftop pool and the dining experience was superb with delicious Balkan cuisine. Highly recommend for a relaxing getaway."
  }
];

export const gallery = [
  {
    url: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/406119973.jpg?k=fb8497d1920659cfad1bca7698a7ed10e9e441226f11ecdbd2793ea3e79ef995&o=",
    category: "Pool",
    alt: "Hotel rooftop pool with sea view"
  },
  {
    url: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462356.jpg?k=8f8897f1e6ad0960acbbd01f9914d9c630e2754e89605185861d157ef8876226&o=",
    category: "Rooms",
    alt: "Room with sea view balcony"
  },
  {
    url: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/475587574.jpg?k=032f83580f4cb215eb4c60b08082ce768f435b765f71507d18cbbedb9605a0f8&o=",
    category: "Rooms",
    alt: "Double room interior"
  },
  {
    url: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462364.jpg?k=05af0ab224b861572b76d469dddd6bd0abb39688cf5990cb38a172c36319ac8e&o=",
    category: "Pool",
    alt: "Pool area"
  },
  {
    url: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487415.jpg?k=fb3cbc4adb4460391b420a1ffc7989e0890fe803417daf91ebdb7939789aa986&o=",
    category: "Terrace",
    alt: "Dining terrace"
  },
  {
    url: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320487412.jpg?k=ff24fccaf0c55c99944e7786cd3a3aabf3882352d8d62af3a7eaba53e62d73ae&o=",
    category: "Bathroom",
    alt: "Modern bathroom"
  },
  {
    url: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/320462352.jpg?k=74f74428972ebdacbbee9db68d31ca7ceb2598000417807224216c4e56a1fc5b&o=",
    category: "Rooms",
    alt: "Room interior"
  },
  {
    url: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/666288681.jpg?k=267a30ca91bb636e8b35aeb2018495a91350de37bb2340416ed9f1cde4b0aaf1&o=",
    category: "Exterior",
    alt: "Hotel exterior"
  }
];

export const faqs = [
  {
    question: "What is the location of Hotel La Rosa Negra?",
    answer: "Hotel La Rosa Negra is located at Kepi i Gjeranave on Long Beach in Ulcinj, Montenegro. We are positioned at the beginning of Long Beach, the longest sandy beach in Montenegro, with beautiful views of the entire beach."
  },
  {
    question: "Does Hotel La Rosa Negra have a swimming pool?",
    answer: "Yes, we have outdoor swimming pools including a rooftop pool and a dedicated children's pool for families with young ones. The pool area offers beautiful views and a relaxing atmosphere."
  },
  {
    question: "What are the check-in and check-out times?",
    answer: "Check-in at Hotel La Rosa Negra is from 2:00 PM to 11:30 PM and check-out is from 2:30 AM to 10:00 AM. Please contact us in advance if you need to arrive outside these hours."
  },
  {
    question: "Is free parking available?",
    answer: "Yes, Hotel La Rosa Negra provides free private parking for all guests. The parking area is secure and conveniently located on the hotel premises."
  },
  {
    question: "How far is the hotel from the airport?",
    answer: "Hotel La Rosa Negra is approximately 1.5 hours drive from Podgorica Airport (TGD). We offer airport shuttle service for our guests. Please contact us in advance to arrange your pickup."
  },
  {
    question: "What beaches are near the hotel?",
    answer: "Hotel La Rosa Negra is located directly on Long Beach (Velika Plaza), the longest sandy beach in Montenegro at 13km. The beach is right at our doorstep, making it perfect for beach lovers."
  },
  {
    question: "What room types are available?",
    answer: "We offer various room types including Economy Double Rooms, Triple Rooms, Family Rooms with Terrace, Double Rooms with Balcony and Sea View, Executive Triple Rooms, Twin Rooms, and spacious Apartments with kitchenettes. All rooms feature modern amenities including air conditioning, free WiFi, and flat-screen TVs."
  },
  {
    question: "Do you offer bicycle and car rental services?",
    answer: "Yes, Hotel La Rosa Negra has both bicycle rental and car rental services available. Please contact our front desk for rates and availability."
  }
];

export const nearbyAttractions = [
  {
    name: "Velika Plaza (Long Beach)",
    description: "13km sandy beach - one of the longest on the Adriatic Sea",
    distance: "0 km",
    rating: 8.9
  },
  {
    name: "Ulcinj Old Town",
    description: "Historic fortress with stunning views and charming cobblestone streets",
    distance: "2.5 km"
  },
  {
    name: "Mala Plaza (Small Beach)",
    description: "Popular city beach with crystal clear waters and beach bars",
    distance: "3.2 km"
  },
  {
    name: "Ada Bojana",
    description: "River island paradise famous for kitesurfing and untouched nature",
    distance: "12 km"
  }
];
